import { OHIO_COUNTIES } from '../constants';

/**
 * Get county name by SVG path ID
 * @param {string} pathId - The SVG path ID
 * @returns {string|null} County name or null if not found
 */
export const getCountyName = (pathId) => {
  const entry = OHIO_COUNTIES.find(entry => entry[1] === pathId);
  return entry ? entry[0] : null;
};

/**
 * Get SVG path ID by county name
 * @param {string} countyName - The county name
 * @returns {string|null} Path ID or null if not found
 */
export const getCountyPath = (countyName) => {
  const entry = OHIO_COUNTIES.find(entry => entry[0] === countyName);
  return entry ? entry[1] : null;
};

/**
 * Get county name by zip code
 * @param {string} zipcode - The zip code to search for
 * @returns {string|null} County name or null if not found
 */
export const getCountyByZipcode = (zipcode) => {
  const entry = OHIO_COUNTIES.find(entry => entry[2].includes(zipcode));
  return entry ? entry[0] : null;
};

/**
 * Get complete county details
 * @param {string} countyName - The county name
 * @returns {Array|null} County details array [name, pathId, zipcodes] or null
 */
export const getCountyDetails = (countyName) => {
  return OHIO_COUNTIES.find(entry => entry[0] === countyName) || null;
};

/**
 * Filter counties by search query
 * @param {string} query - Search query string
 * @returns {Array<string>} Array of matching county names
 */
export const filterCountiesByQuery = (query) => {
  return OHIO_COUNTIES
    .filter((county) => county[0].toLowerCase().startsWith(query.toLowerCase()))
    .map(county => county[0]);
};

/**
 * Filter zip codes by search query
 * @param {string} query - Search query string
 * @param {string|null} selectedCounty - Optional county to limit search to
 * @returns {Array<string>} Array of matching zip codes
 */
export const filterZipcodesByQuery = (query, selectedCounty = null) => {
  let counties = OHIO_COUNTIES;

  // If a county is selected, get only its zip codes
  if (selectedCounty) {
    const countyEntry = OHIO_COUNTIES.find(entry => entry[0] === selectedCounty);
    if (countyEntry && countyEntry[2]) {
      return countyEntry[2]
        .split(',')
        .map(zip => zip.trim())
        .filter(zip => zip.includes(query));
    }
    return [];
  }

  // Otherwise, search all counties
  return counties
    .filter((county) => county[2] && county[2].includes(query))
    .flatMap(county => county[2].split(',').map(zip => zip.trim()))
    .filter(zip => zip.includes(query));
};
